import { Folder } from '@anm/api/modules/videoFolder';
import { BreadcrumbItemProps } from '@anm/components/Breadcrumbs/BreadcrumbItem';
import { DEFAULT_VIDEO_NAME } from '@anm/constants/my-videos';
import isDraft from '@anm/helpers/project/isDraft';
import { RouteParams } from 'next-routes';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import useFolderTree from '../../../hooks/useFolderTree';
import routes from '../../../routes';
import { projectSelectors } from '../../../store/modules/project';
import { videoFolderSelectors } from '../../../store/modules/videoFolder';

import { isNotFoundErrorCode } from './../../my-projects/VideoFolders/helpers';

export type ProjectBreadcrumbItem = BreadcrumbItemProps & {
  path: string | null;
  isDraft: boolean;
};
export const useBreadcrumbData = (projectId: string) => {
  const makeFolderTreeListByPath = useSelector(
    videoFolderSelectors.makeFolderTreeListByPath
  );

  const folderError = useSelector(
    videoFolderSelectors.selectCurrentFolderError
  );

  const project = useSelector(projectSelectors.selectCurrentProject);
  const folderTree = useFolderTree();
  const folderPath = useSelector(state =>
    videoFolderSelectors.getFolderPathFor(state, project?.folderId)
  );

  if (!project || !folderTree || isNotFoundErrorCode(folderError!)) {
    return null;
  }

  const projectBreadcrumbItem: ProjectBreadcrumbItem = {
    id: projectId,
    name: project.name || DEFAULT_VIDEO_NAME,
    path: null,
    isDraft: isDraft(project)
  };

  const breadcrumbData: (
    | Folder
    | ProjectBreadcrumbItem
  )[] = makeFolderTreeListByPath(folderPath || 'root-wave', true);

  return [...breadcrumbData, projectBreadcrumbItem];
};

const { Router } = routes;

export const useOpenFolderCallback = () =>
  useCallback(({ path }: { path?: string | null }) => {
    const routeName = path ? 'my-projects-folder' : 'my-projects';
    Router.pushRoute(routeName, {
      ...((path && { folderPath: path.replace('/', '') }) as RouteParams)
    });
  }, []);
